import { render } from "./SuggesstionPage.vue?vue&type=template&id=2b29742d&scoped=true"
import script from "./SuggesstionPage.vue?vue&type=script&lang=js"
export * from "./SuggesstionPage.vue?vue&type=script&lang=js"

import "./SuggesstionPage.vue?vue&type=style&index=0&id=2b29742d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b29742d"]])

export default __exports__